import './App.css';
import { CssBaseline, ThemeProvider } from '@mui/material';
import SignIn from './pages/admin/Authentification/SignIn';
import { createAppTheme } from "./components/theme";
import React from 'react';
import { ColorModeContext } from './context/ColorModeContext';
import { Route, Routes } from 'react-router';
import PrivateRoute from './routes/PrivateRoute';
import NotFound from './pages/admin/NotFound';
import Dashboard from './Dashboard';
import OAuthSuccess from './pages/admin/OAuthSuccess';
import ClientLayout from './layouts/ClientLayout';
import RootRedirect from './pages/RootRedirect';

function App() {
  const [mode, setMode] = React.useState(() => localStorage.getItem('colorMode') || 'light');

  const theme = React.useMemo(() => createAppTheme(mode), [mode]);
  const colorModeValue = React.useMemo(() => ({
    mode,
    toggleColorMode: () => {
      setMode((current) => {
        const next = current === 'dark' ? 'light' : 'dark';
        localStorage.setItem('colorMode', next);
        return next;
      });
    },
  }), [mode]);

  return (
    <ColorModeContext.Provider value={colorModeValue}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Routes>
        <Route path="/" element={<RootRedirect />} />
        <Route path="/login" element={<SignIn />} />
        <Route path="/oauth-success" element={<OAuthSuccess />} />
        <Route
          path="/dashboard/*"
          element={
            <PrivateRoute allowedRoles={["admin"]}>
              <Dashboard />
            </PrivateRoute>
          }
        >

        </Route>
         <Route
          path="/app/*"
          element={
            <PrivateRoute allowedRoles={["client"]}>
              <ClientLayout />
            </PrivateRoute>
          }
        >

        </Route>
        <Route path="*" element={<NotFound />} />
        </Routes>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}

export default App;
